<template>
  <div class="button" :class="[{ 'disabled': disabled }, type ]" >
    <div class="copy">{{ text }}</div>
    <span v-if="icon" class="icon mdi" :class="icon" ></span>
  </div>
</template>

<script>

export default {
  name: 'Button',
  props: {
    text: String,
    icon: String,
    type: {
      type: String,
      default: 'primary' // primary || tertiary || danger
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .button {
    width: 100%;
    height: 35px;
    position: relative;
    padding: 10px;
    cursor: pointer;
    border-radius: 3px;
    text-align: center;
    background-color: $brand-primary-button;

    display: flex;
    align-items: center;
    justify-content: center;

    // Primary
    &.primary {
      background-color: $brand-primary-button;
      border: solid 1px $brand-primary-button;
      color: $general-white;

      &:hover {
        background-color: $brand-primary-button-hover;
        border: solid 1px $brand-primary-button-hover;
      }

      &.disabled {
        pointer-events: none;
        background-color: $brand-primary-button-disabled;
        border: solid 1px $brand-primary-button-disabled;
      }
    }

    // Tertiary
    &.tertiary {
      background-color: $general-white;
      border: solid 1px $brand-primary-button;
      color: $brand-primary-button;

      &:hover {
        background-color: $brand-tertiary-button-hover;
      }

      &.disabled {
        pointer-events: none;
        background-color: $general-white;
        border: solid 1px $brand-primary-button-disabled;
        color: $brand-primary-button-disabled;
      }
    }

    // Danger
    &.danger {
      background-color: $general-white;
      border: solid 1px $brand-danger-button;
      color: $brand-danger-button;

      &:hover {
        background-color: $brand-danger-button-hover;
      }

      &.disabled {
        pointer-events: none;
        background-color: $general-white;
        border: solid 1px $brand-danger-button-disabled;
        color: $brand-danger-button-disabled;
      }
    }

    .copy {
      width: auto;
      position: relative;
      font-size: 12px;
      font-weight: 700;
      padding: 0 5px;
    }

    .icon {
      width: auto;
      height: auto;
      font-size: 14px !important;
    }
  }
</style>
